module.exports = __webpack_public_path__ + "img/win.ebc6f99b.png";